import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { PayrollProviderList } from '../../components/payroll/PayrollProviderList';
import { PayrollConnector } from '../../components/payroll/PayrollConnector';
import { motion } from 'framer-motion';
import { Briefcase, CheckCircle } from 'lucide-react';
export function PayrollIntegration() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-4884">
      <Sidebar data-id="element-4885" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-4886">
        <DashboardHeader data-id="element-4887" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-4888">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-4889">
            <div className="mb-6 lg:mb-8" data-id="element-4890">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-4891">
                Payroll Integration
              </h1>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-4892">
                Connect your employer payroll for automated rent deductions.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-6 lg:gap-8" data-id="element-4893">
              <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-xl p-6 transition-colors" data-id="element-4894">
                <h3 className="text-lg font-semibold text-blue-900 dark:text-blue-300 mb-2 flex items-center gap-2 truncate" data-id="element-4895">
                  <Briefcase className="h-5 w-5 flex-shrink-0" data-id="element-4896" />
                  <span className="truncate" data-id="element-4897">Why connect payroll?</span>
                </h3>
                <ul className="space-y-2 mt-4" data-id="element-4898">
                  {['Automated monthly payments (never miss a due date)', 'Improved credit score & reliability rating', 'Access to lower service fees', 'Simplified income verification'].map((benefit, idx) => <li key={idx} className="flex items-start text-sm text-blue-800 dark:text-blue-400" data-id="element-4899">
                      <CheckCircle className="h-4 w-4 mr-2 mt-0.5 text-blue-600 dark:text-blue-400 flex-shrink-0" data-id="element-4900" />
                      <span className="break-words" data-id="element-4901">{benefit}</span>
                    </li>)}
                </ul>
              </div>

              <PayrollConnector data-id="element-4902" />

              <div data-id="element-4903">
                <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 truncate" data-id="element-4904">
                  Supported Providers
                </h3>
                <PayrollProviderList data-id="element-4905" />
              </div>
            </div>
          </motion.div>
        </div>
      </main>
    </div>;
}